import * as yup from 'yup';
import { NewsRequest } from '@api/admin/adminGeneratedApi';

export const publicationValidation: yup.Schema<Pick<NewsRequest, 'title' | 'url'>> = yup.object({
  startDate: yup
    .date()
    .required('Обязательное поле.')
    .transform(function (value, originalValue) {
      if (this.isType(value)) return value;
      return originalValue.toDate();
    }),
  type: yup
    .object({
      value: yup.string(),
      label: yup.string(),
    })
    .typeError('Обязательное поле.')
    .required('Обязательное поле.'),
  title: yup.string().min(5, 'Минимальное количество символов = 5').required('Обязательное поле.'),
  url: yup.string().min(5, 'Минимальное количество символов = 5').required('Обязательное поле.'),
  newsTagIds: yup.array(
    yup.object({
      label: yup.string(),
      value: yup.string(),
    }),
  ),
  authorIds: yup.array(
    yup.object({
      label: yup.string(),
      value: yup.string(),
    }),
  ),
  mainImage: yup.object({
    file: yup
      .mixed()
      .nullable()
      .test('fileSize', 'The file is too large', (value: any, { path, createError }) => {
        if (!value) return true;

        if (value.size > 5 * 1024 * 1024) {
          return createError({ path, message: 'Размер изображения не должен превышать 5Мб' });
        }

        return true;
      }),
  }),
  photoGallery: yup.array().of(
    yup.object({
      file: yup
        .mixed()
        .nullable()
        .test('fileSize', 'The file is too large', (value: any, { path, createError }) => {
          if (!value) return true;

          if (value.size > 5 * 1024 * 1024) {
            return createError({ path, message: 'Размер изображения не должен превышать 5Мб' });
          }

          return true;
        }),
      alt: yup.string().nullable(),
      metadata: yup.string().nullable(),
    }),
  ),
  snippetPhoto: yup
    .object({
      file: yup
        .mixed()
        .nullable()
        .test('fileSize', 'The file is too large', (value: any, { path, createError }) => {
          if (!value) return true;

          if (value.size > 5 * 1024 * 1024) {
            return createError({ path, message: 'Размер изображения не должен превышать 5Мб' });
          }

          return true;
        }),
    })
    .nullable(),
});
